import { Action } from 'redux';
import * as PermissionActions from './permissions.actions';
import { createSelector } from 'reselect';
import { PermissionTypes } from '@iv/store/permissions/permissions.models';

export interface PermissionState {
  entities: PermissionTypes[];
}

const initialState: PermissionState = {
  entities: []
};

export const PermissionReducer = function (state: PermissionState = initialState, action: Action): PermissionState {
  switch (action.type) {
    case PermissionActions.ADD_PERMISSIONS: {
      const permissions = (<PermissionActions.AddPermissionsAction>action).permissions;
      return {
        entities: [...permissions]
      };
    }

    default:
      return state;
  }
};

export const getPermissionState = (state): PermissionState => {
  return state.permissions;
};

export const getPermissions = createSelector(
  getPermissionState,
  (state: PermissionState) => {
    return state.entities;
  }
);
